import React, { memo, useState, useEffect, useContext, useRef } from "react";
import Modal from "./Modal";
import "./styles/scss/CodeConvert.scss";
import {
	Request,
	catchErrorHandle,
	CTX_STATE,
	CTX_DISPATCH,
	refreshUserInfo,
} from "../common";

function App(props) {
	const { isShow, onClose } = props;
	const [msg, setMsg] = useState("");
	const _state = useContext(CTX_STATE);
	const _dispatch = useContext(CTX_DISPATCH);
	const ref = useRef(null);

	const codeConvert = async () => {
		try {
			const code = ref.current.value;

			if (!code) {
				setMsg("请输入兑换码");
				return;
			}

			const req = new Request({
				url: "/api/user/v1/exchange_code",
				method: "post",
				source: 2,
				headers: {
					token: _state.token,
				},
				data: {
					code,
				},
			});

			const res = await req.send();

			if (res.base.code === "200") {
				onClose();

				Modal.tips({
					icon: "succ",
					contentHead: (
						<p>
							你已成功兑换
							<span style={{ color: "#5DFE97" }}>{res.data?.duration}小时大会员！</span>
						</p>
					),
					contentBody: "",
					onOk: (c) => {
						c();
					},
					okText: "确定",
					cancelBtn: null,
				});

				refreshUserInfo(_state.token, _state.userInfo, _dispatch);
			} else {
				throw new Error(res.base.msg);
			}
		} catch (error) {
			setMsg(catchErrorHandle(error));
		}
	};

	useEffect(() => {
		if (isShow) return;
		ref.current && (ref.current.value = "");
	}, [isShow]);

	useEffect(() => {
		msg &&
			setTimeout(() => {
				setMsg("");
			}, 3000);
	}, [msg]);

	return (
		<Modal className="popup-code-convert" visible={isShow} onClose={onClose}>
			<div className="title">口令兑换</div>
			<input
				ref={ref}
				type="text"
				placeholder="请输入口令或兑换码"
				className="code"
			/>
			<div className="convert-msg">{msg}</div>
			<div className="btn-group">
				<button
					type="button"
					onClick={() => {
						onClose();
					}}
				>
					取消
				</button>

				<button
					type="button"
					onClick={() => {
						codeConvert();
					}}
				>
					确定
				</button>
			</div>
		</Modal>
	);
}

export default memo(App);
